import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Chart = props => (
  <SvgIcon {...props} viewBox="0 0 19.28 15.683">
    <path id="Chart_Filled" data-name="Chart Filled" d="M180.773,189.461v-3.1a.6.6,0,0,0-.6-.6h-6.627v-2.5a2.41,2.41,0,1,0-1.2,0v2.5h-6.627a.6.6,0,0,0-.6.6v3.1a2.41,2.41,0,1,0,1.2,0v-2.5h6.025v2.5a2.41,2.41,0,1,0,1.2,0v-2.5h6.025v2.5a2.41,2.41,0,1,0,1.2,0Z" transform="translate(-163.301 -178.522)" />
  </SvgIcon>
);

export default Chart;
